import React, { useState } from 'react'
import Logo_path from '../../Components/Logo_path'

function ViewComplaints() {
    const [imageSizeFull,setImageSizeFull]=useState(false)
    const [isSolved,setIsSolved]=useState(false)
  return (
    <>
    <div className='w-full h-full flex justify-center'>
    <div className='flex flex-col items-center w-full '>
       
       <div className='w-11/12 h-full'>
    <Logo_path AdminOrHome={'Admin'} Directory={'view complaints'}/>
    </div>
    </div>
    </div>
    
    {/* contents */}
    <div className='flex w-full justify-center mt-10' style={{fontFamily: "Ropa Sans"}}>
        <div className={`${imageSizeFull?'w-11/12 flex md:flex-row flex-col flex-wrap justify-center items-center':'w-11/12 flex md:flex-row flex-col flex-wrap justify-between md:items-start items-center'}`}>

            {/* complaint image */}
            <div className={`${imageSizeFull?'w-11/12 mb-10 flex justify-center':'md:w-4/12 w-10/12'}`}><img onClick={e=>setImageSizeFull(!imageSizeFull)} src="https://awayandfar.com/wp-content/uploads/2019/01/Snowmobiles.jpg"  className='w-full rounded' alt="" /></div>
            
            {/* description */}
            <div className='md:w-7/12 w-10/12 flex flex-col md:items-start items-center'>
                {/* heading */}
                <div className='flex flex-wrap md:justify-between justify-center md:w-9/12 w-full'>
                   <div className='md:w-6/12 w-full flex md:mt-0 mt-6 md:mb-0 mb-6'><h5 className='md:text-xl text-sm font-bold'>Complaint</h5></div>
                    <div className='md:w-6/12 w-full flex'><button onClick={e=>setIsSolved(true)} className='md:w-7/12 w-9/12 bg-green-500 text-white p-2 rounded-full'>Mark as solved</button></div>
                    </div>
                
                {/* desc */}
                <div className='flex flex-row md:w-9/12 w-full mt-6 justify-center'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Complaint id</div>
                <div className='w-6/12'>fhfreut893</div>
              </div>

              <div className='flex flex-row md:w-9/12 w-full mt-6'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Complaint date</div>
                <div className='w-6/12'>09-01-2024</div>
              </div>

              <div className='flex flex-row md:w-9/12 w-full mt-6'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Action taken</div>
                <div className={`${isSolved?'w-6/12 text-green-700':'w-6/12 text-red-700'}`}>{isSolved?'Solved':'Unsolved'}</div>
              </div>
{/* 
              <div className='flex flex-row md:w-9/12 w-10/12 mt-6'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Complaint</div>
                <div className='w-6/12 '>Lorem ipsum dolor sit amet consectetur adipisicing elit. </div>
              </div> */}

              <div className='mt-10'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat facilis temporibus praesentium dicta, saepe, consequuntur ratione a ducimus fugiat, voluptatum cumque. Debitis at dignissimos perferendis sint tenetur unde vero minus.</div>

            </div>
        </div>
    </div>
    </>
  )
}

export default ViewComplaints